import { QBox } from '@qualio/ui-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TrainingAssessmentEmptyState } from './TrainingAssessmentEmptyState';
import { TrainingAssessmentQuestionCard } from './TrainingAssessmentQuestionCard';
import { TrainingAssessment as TrainingAssessmentType } from './types/trainingAssessment';

type TrainingAssessmentProps = {
  questions?: TrainingAssessmentType['questions'];
};

export const TrainingAssessment: React.FC<TrainingAssessmentProps> = ({
  questions,
}) => {
  const { t } = useTranslation();

  if (!questions || questions.length === 0) {
    return <TrainingAssessmentEmptyState />;
  }

  return (
    <QBox marginTop="16px" data-cy="training-assessment-layout">
      {questions?.map(({ question, answers, id }, index) => (
        <TrainingAssessmentQuestionCard
          key={id}
          questionLabel={t('trainingAssessment.questionNumber', {
            number: index + 1,
          })}
          question={question}
          answers={answers}
        />
      ))}
    </QBox>
  );
};
